import styles from './rejected-login.module.scss';
import { Box, Container, CreateHeaders, HeaderSizeEnum, SumRows, textHeader } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { UseTableHook } from '../../requestUtils';
import PageTitle from '../../page-title/page-title';
import FullTable from '../../full-table/full-table';
import { ValueFormatterParams } from 'ag-grid-community';
import RejectedLoginGrid from '../rejected-login-grid/rejected-login-grid';
import { IDeniedLogon } from '../../_models/denied-logon';
import { useTranslation } from 'react-i18next';


/* eslint-disable-next-line */
export interface RejectedLoginProps { }

export function RejectedLogin(props: RejectedLoginProps) {

  const persentRenderer = (params: ValueFormatterParams) => {
    if (params.data.isSummary) return "";
    return params.value + '%';
  };

  const { t } = useTranslation();
  const { data, onDateChange, isLoading, dateRange, forGroup, onForGroupToggle, productFilter, getData } = UseTableHook<IDeniedLogon>(`reports/rejected-logins`, { supportForGroup: true });

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">

            <PageTitle title={t("app.rejectedLogin")} />
            <FullTable
              headers={CreateHeaders([
                textHeader("companyName", "Firma", HeaderSizeEnum.EXTRA_LARGE),
                textHeader("companyNumber", "Kundenr.", HeaderSizeEnum.MEDIUM),
                textHeader("product", "Produkt", HeaderSizeEnum.EXTRA_LARGE),
                textHeader("licenseNumber", "Lisensnr.", HeaderSizeEnum.MEDIUM),
                textHeader("licenseModel", "Lisensmodell", HeaderSizeEnum.LARGE),
                textHeader("newLicensing", "Lisenssystem", HeaderSizeEnum.MEDIUM),
                textHeader("seats", "Seter", HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                }),
                textHeader("approved", "Godkjente", HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                textHeader("rejected", "Avviste", HeaderSizeEnum.SMALL, {
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header",
                  summary: SumRows
                }),
                textHeader("rejectedPersent", "Avviste (%)", HeaderSizeEnum.SMALL, {
                  renderer: persentRenderer,
                  cellStyle: { justifyContent: 'right' },
                  headerClass: "ag-right-aligned-header"
                })
              ])}
              tableConfigName="rejectedLogins"
              url='reports/rejected-logins'
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default RejectedLogin;